import { FormTemplateTypeEnum } from "../_common/enum/forms/fomTemplateType.enum";
import { FormStatusEnum } from "../_common/enum/forms/formStatus.enum";
import { IFormSectionManage } from "../_common/models/formSection";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";
import { accountService } from "./accounts.service";

const API_NAME = "form";

export const formService = {
    get,
    getStatus,
    getForReview,
    getAll,
    getInsuranceDatabase,
    post,
    put,
    complete,
    disable,
    getCurrentStep,
    getForTable,
    getForEmployeeTable,
    getForUserTable,
    hasConsent,
    createSample,
    getByType,
    getShoppingCart,
    approve,
    returnForm,
    updateComment,
    createByType,
    getCurrent,
    getCurrentQuestionnaire,
    createQuestionnaireByName,
    getAllCurrent,
    getComment,
    createAction,
    submit(model?: IFormSectionManage) { return model?.id ? put(model) : post(model) }
};


function hasConsent(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/hasConsent/?id=${id}`, requestOptions).then(handleResponse);
}

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/get/?id=${id}`, requestOptions).then(handleResponse);
}

function getComment(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getComment/?id=${id}`, requestOptions).then(handleResponse);
}

function getStatus(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getStatus/?id=${id}`, requestOptions).then(handleResponse);
}

function getCurrent(formTemplateType: FormTemplateTypeEnum, userId: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getCurrent/?formTemplateType=${formTemplateType}&userId=${userId || ''}`, requestOptions).then(handleResponse);
}

function getAllCurrent(userId: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getCurrent/?userId=${userId || ''}`, requestOptions).then(handleResponse);
}

function getCurrentQuestionnaire(questionnaireName: string, userId: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getCurrentQuestionnaire/?questionnaireName=${questionnaireName}&userId=${userId || ''}`, requestOptions).then(handleResponse);
}

function getShoppingCart(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getShoppingCart/?id=${id}`, requestOptions).then(handleResponse);
}

function getInsuranceDatabase(query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getInsuranceDatabase/?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getAll(query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getCurrentStep() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getCurrentStep/`, requestOptions).then(handleResponse);
}

function getForUserTable(query: any, userId: string) {
    userId = userId || accountService.currentUserValue.id;

    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForUserTable/?userId=${userId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForTable(query: any, clientId?: number, formFilter?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForTable/?formFilter=${formFilter || ""}&clientId=${clientId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForEmployeeTable(query: any, clientId?: number, formFilter?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetForEmployeeTable/?formFilter=${formFilter || ""}&clientId=${clientId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getForReview(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getForReview/?id=${id}`, requestOptions).then(handleResponse);
}

function createSample(id: number) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createSample/?id=${id}`, requestOptions).then(handleResponse);
}

function createAction(id: number, actionId: number) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createAction/?id=${id}&actionId=${actionId}`, requestOptions).then(handleResponse);
}

function createByType(formTypeId: FormTemplateTypeEnum, userId?: string) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createByType/?formTypeId=${formTypeId}&userId=${userId}`, requestOptions).then(handleResponse);
}

function createQuestionnaireByName(questionnaireName: string, userId?: string) {
    const requestOptions = { method: 'POST', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/createQuestionnaireByName/?questionnaireName=${questionnaireName}&userId=${userId}`, requestOptions).then(handleResponse);
}

function post(model?: IFormSectionManage) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

function put(model?: IFormSectionManage) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}
function complete(id: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/complete/?id=${id}`, requestOptions).then(handleResponse);
}

function approve(id: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/approve/?id=${id}`, requestOptions).then(handleResponse);
}

function returnForm(id: number) {
    const requestOptions = { method: 'PUT', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/returnForm/?id=${id}`, requestOptions).then(handleResponse);
}

function updateComment(model: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/updateComment/`, requestOptions).then(handleResponse);
}

function disable(id: number, formStatusId: FormStatusEnum) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/?id=${id}&formStatusId=${formStatusId}`, requestOptions).then(handleResponse);
}
function getByType(formTypeId: FormTemplateTypeEnum, userId?: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getByType/?formTypeId=${formTypeId}&userId=${userId}`, requestOptions).then(handleResponse);
}
